import Footer from './Footer.vue'
import Header from './Header/Header.vue'
import Sidebar from './Sidebar/Sidebar.vue'
import Switch from './Switch.vue'

export {
  Footer,
  Header,
  Sidebar,
  Switch
}



// WEBPACK FOOTER //
// ./src/components/index.js